import { queryGraphQL } from 'common/util/query';
import { addApplicationMessages } from 'common/actions/applicationMessagesActions';
import { nodeWithArgs, toQuery } from 'common/util/queryHelper';

export const REQUESTING_BINDER_EXPORT = 'REQUESTING_BINDER_EXPORT';
export const BINDER_EXPORT_REQUESTED = 'BINDER_EXPORT_REQUESTED';
export const BINDER_EXPORT_REQUEST_FAILED = 'BINDER_EXPORT_REQUEST_FAILED';

/**
 * Requests a binder export from the server
 * @param {string} binderId - The ID of the binder to export
 * @param {Object} exportOptions - Optional export configuration
 * @returns {Function} Redux thunk function
 */
export function requestBinderExport(binderId, exportOptions = {}) {
    return async (dispatch) => {
        dispatch(requestingBinderExport());

        const query = nodeWithArgs('requestBinderExport', {
            binderId,
            exportOptions
        }, [
            'exportId',
            'status',
            'progress',
            'requestedAt',
            'createdAt',
            'message'
        ]);

        try {
            const response = await queryGraphQL(toQuery(query));
            
            if (response.errors) {
                dispatch(addApplicationMessages('error', response.errors.map(e => e.message)));
                dispatch(binderExportRequestFailed(response.errors));
            } else {
                const exportData = response.data.requestBinderExport;
                const successMessage = exportData.message;
                dispatch(addApplicationMessages('success', [successMessage]));
                dispatch(binderExportRequested(exportData));
            }
        } catch (error) {
            const errorMessage = error.message || 'Failed to request binder export. Please try again.';
            dispatch(addApplicationMessages('error', [errorMessage]));
            dispatch(binderExportRequestFailed([error]));
        }
    };
}

function requestingBinderExport() {
    return {
        type: REQUESTING_BINDER_EXPORT,
        payload: true
    };
}

function binderExportRequested(exportJob) {
    return {
        type: BINDER_EXPORT_REQUESTED,
        payload: exportJob
    };
}

function binderExportRequestFailed(errors) {
    return {
        type: BINDER_EXPORT_REQUEST_FAILED,
        payload: errors
    };
}